
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';
import Input from '../../../components/base/Input';
import TopNavigation from '../../../components/feature/TopNavigation';

export default function RegisterPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setLoading(false);
      navigate('/otp');
    }, 1500);
  };

  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <TopNavigation 
        title="إنشاء حساب جديد"
        showBack={true}
      />
      
      <div className="pt-16 px-6 py-8">
        <div className="max-w-sm mx-auto">
          {/* App Logo */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center mb-4 mx-auto">
              <i className="ri-car-line text-2xl text-white w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h1 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: '"Pacifico", serif' }}>
              سامي عبدالسلام
            </h1>
            <p className="text-gray-600">
              أنشئ حسابك الجديد
            </p>
          </div>

          {/* Register Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="الاسم الكامل"
              type="text"
              value={formData.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              placeholder="أدخل اسمك الكامل"
              icon={<i className="ri-user-line w-5 h-5 flex items-center justify-center"></i>}
              required
            />

            <Input
              label="رقم الجوال"
              type="tel"
              value={formData.phone}
              onChange={(e) => handleInputChange('phone', e.target.value)}
              placeholder="05xxxxxxxx"
              icon={<i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>}
              required
            />

            <Input
              label="البريد الإلكتروني (اختياري)"
              type="email"
              value={formData.email}
              onChange={(e) => handleInputChange('email', e.target.value)}
              placeholder="example@email.com"
              icon={<i className="ri-mail-line w-5 h-5 flex items-center justify-center"></i>}
            />

            <Input
              label="كلمة المرور"
              type="password"
              value={formData.password}
              onChange={(e) => handleInputChange('password', e.target.value)}
              placeholder="أدخل كلمة المرور"
              icon={<i className="ri-lock-line w-5 h-5 flex items-center justify-center"></i>}
              required
            />

            <Input
              label="تأكيد كلمة المرور"
              type="password"
              value={formData.confirmPassword}
              onChange={(e) => handleInputChange('confirmPassword', e.target.value)}
              placeholder="أعد إدخال كلمة المرور"
              icon={<i className="ri-lock-line w-5 h-5 flex items-center justify-center"></i>}
              required
            />

            <Button
              type="submit"
              className="w-full mt-6"
              size="lg"
              loading={loading}
            >
              إنشاء حساب
            </Button>
          </form>

          {/* Login Link */}
          <div className="mt-6 text-center">
            <p className="text-gray-600">
              لديك حساب؟{' '}
              <button
                onClick={() => navigate('/login')}
                className="text-purple-600 font-medium hover:text-purple-700"
              >
                سجل دخولك
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
